import { __decorate } from "tslib";
import { injectable } from '@/inversify.config';
import { labServiceApiUrlPrefix } from '@cores/constants/envConfig';
import psHttp from '@patsnap/common-ps-http';
import _ from 'lodash';
let LabApi = class LabApi {
    getBatchUsedByAnchorApi(anchors) {
        return psHttp({
            url: `${labServiceApiUrlPrefix}/apps/app/usedByAnchor`,
            method: 'POST',
            transformCode: true,
            data: {
                anchors,
            },
        }).then(({ data }) => {
            return _.get(data, 'data');
        });
    }
};
LabApi = __decorate([
    injectable()
], LabApi);
export { LabApi };
